// extracted by mini-css-extract-plugin
export default {"buttons-container":"DefaultNominals_buttons-container__g+P2z","container":"DefaultNominals_container__Ai54X"};